import { PERMISSIONS_GENERAL, PERMISSIONS_SUBSCRIBED_PLAN } from 'constants/permissions';
import { SCOPES } from 'constants/roles';

export default [
  {
    name: 'my-team-list',
    label: 'label.my_team',
    navigationIcon: 'far fa-hospital',
    url: '/professional/persons/my-team',
    scope: SCOPES.INSTANCE_STAFF,
    requiredSubscribedFeature: PERMISSIONS_SUBSCRIBED_PLAN.TEAM_MEMBERS,
    pages: [
      {
        type: 'item',
        navigationIcon: 'far fa-id-card-alt',
        label: 'label.details',
        name: 'team-member-details',
        url: '/professional/persons/my-team/{id}/details',
      },
      {
        type: 'item',
        navigationIcon: 'far fa-key',
        label: 'label.roles',
        name: 'team-member-roles',
        url: '/professional/persons/my-team/{id}/roles',
        scope: SCOPES.INSTANCE_MGMT,
      },
      {
        type: 'item',
        navigationIcon: 'fas fa-sliders-v',
        label: 'label.status',
        name: 'team-member-status',
        url: '/professional/persons/my-team/{id}/status',
        scope: SCOPES.INSTANCE_MGMT,
      },
      {
        type: 'item',
        navigationIcon: 'far fa-trash',
        class: 'is-delete',
        label: 'label.delete',
        name: 'team-member-delete',
        url: '/professional/persons/my-team/{id}/delete',
        requiredPermissionsGeneral: PERMISSIONS_GENERAL.DELETE,
        scope: SCOPES.INSTANCE_MGMT,
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/data/navigations/person/navigation-person-my-team.js